import { Section } from '@modules/fhirQuestionnaire/Section'
import { TransformConfig } from './BuildConfig'
import cloneDeep from 'lodash/cloneDeep'

export function transformSections(
  sections: Section[],
  transformConfigs: readonly TransformConfig[]
) {
  return sections.map((section) => {
    const transformConfigForSection = transformConfigs.find(
      (config) => config.textId.toLowerCase() === section.text.toLowerCase()
    )
    if (transformConfigForSection) {
      return {
        ...cloneDeep(section),
        text: transformConfigForSection.replaceTitleTextWith
      }
    }
    return section
  })
}
